import { round } from './math';

export function featureUsage(feature, precision = 1) {
  if (feature) return Math.min(round((feature.current / feature.limit) * 100, precision), 100) || 0;
}
